import setraGtHd1 from "../assets/setra415-gt-hd-1.webp";
import setraGtHd2 from "../assets/setra415-gt-hd-2.webp";
import setraGtHd3 from "../assets/setra415-gt-hd-3.webp";
import setraGtHd4 from "../assets/setra415-gt-hd-4.webp";
import setraGtHd5 from "../assets/setra415-gt-hd-5.webp";
import setraGtHdPlan from "../assets/setra415-gt-hd-plan.webp";
import setraHd1 from "../assets/setra415-hd-1.webp";
import setraHd2 from "../assets/setra415-hd-2.webp";
import setraHd3 from "../assets/setra415-hd-3.webp";
import setraHd4 from "../assets/setra415-hd-4.webp";
import setraHd5 from "../assets/setra415-hd-5.webp";
import setraHdPlan from "../assets/setra415-hd-plan.webp";
import crafter1 from "../assets/volkswagen-crafter-1.webp";
import crafter2 from "../assets/volkswagen-crafter-2.webp";
import crafter3 from "../assets/volkswagen-crafter-3.webp";
import crafter4 from "../assets/volkswagen-crafter-4.webp";
import crafter5 from "../assets/volkswagen-crafter-5.webp";
import sprinter1 from "../assets/mercedes-sprinter-416-1.webp";
import sprinter2 from "../assets/mercedes-sprinter-416-2.webp";
import sprinter3 from "../assets/mercedes-sprinter-416-3.webp";
import sprinter4 from "../assets/mercedes-sprinter-416-4.webp";
import sprinter5 from "../assets/mercedes-sprinter-416-5.webp";

export type Vehicle = {
  id: string;
  name: string;
  images?: string[];
  image?: string;
  planImage?: string;
  seats?: string;
  trunk?: string;
  fuel?: string;
  advantages?: string[];
};

export const sampleBuses: Vehicle[] = [
  {
    id: "1",
    name: "Autobusas SETRA 415 HD",
    images: [setraHd1, setraHd2, setraHd3, setraHd4, setraHd5],
    planImage: setraHdPlan,
    seats: "49+1+1",
    trunk: "550l",
    fuel: "28l/100km",
    advantages: [
      "adv_airConditioning",
      "adv_video",
      "adv_cd",
      "adv_microphone",
      "adv_kitchen",
      "adv_two_fridges",
      "adv_wc",
    ],
  },
  {
    id: "2",
    name: "Autobusas SETRA 415 GT-HD",
    images: [setraGtHd1, setraGtHd2, setraGtHd3, setraGtHd4, setraGtHd5],
    planImage: setraGtHdPlan,
    seats: "49+1+1",
    trunk: "500l",
    fuel: "30l/100km",
    advantages: [
      "adv_airConditioning",
      "adv_video",
      "adv_cd",
      "adv_microphone",
      "adv_kitchen",
      "adv_fridge",
      "adv_wc",
      "adv_separate_heating",
      "adv_navigation",
    ],
  },
];

export const sampleMicrobuses: Vehicle[] = [
  {
    id: "m1",
    name: "Mikroautobusas Volkswagen Crafter",
    images: [crafter1, crafter2, crafter3, crafter4, crafter5],
    seats: "20+1",
    trunk: "110l",
    fuel: "15l/100km",
    advantages: [
      "adv_airConditioning",
      "adv_video",
      "adv_cd",
      "adv_microphone",
      "adv_panoramic_windows",
      "adv_trunk",
    ],
  },
  {
    id: "m2",
    name: "Mikroautobusas Mercedes Sprinter 416",
    images: [sprinter1, sprinter2, sprinter3, sprinter4, sprinter5],
    seats: "20+1",
    trunk: "80l",
    fuel: "13l/100km",
    advantages: [
      "adv_airConditioning",
      "adv_video",
      "adv_cd",
      "adv_microphone",
      "adv_panoramic_windows",
      "adv_trunk",
    ],
  },
];
